import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import AddInstallment from "./AddInstallment";
import EditInstallment from "./EditInstallment";
import { toast } from "react-toastify";
import { AuthContext } from "../../Context/AuthContext";
import Preloader from "../../shared/PreLoaders";

const thStyle = { padding: "10px 12px", fontSize: 12, fontWeight: 700, color: "#2D3748", background: "#F7FAFC", border: "1px solid #E2E8F0", textAlign: "left" };
const tdStyle = { padding: "9px 12px", fontSize: 12, color: "#4A5568", border: "1px solid #E2E8F0" };

const ManageInstallment = () => {
  const [installments, setInstallments] = useState([]);
  const [showAddPopup, setShowAddPopup] = useState(false);
  const [showEditPopup, setShowEditPopup] = useState(false);
  const [currentInstallment, setCurrentInstallment] = useState(null);
  const { permissions } = useContext(AuthContext);
  const [loading, setLoading] = useState(true);
  const Api = process.env.REACT_APP_API;

  useEffect(() => {
    const fetchInstallments = async () => {
      try {
        const response = await axios.get(`${Api}/api/installments`);
        setInstallments(response.data);
      } catch (err) {
        console.error("Error fetching data", err);
      }
      setLoading(false);
    };
    fetchInstallments();
  }, []);

  const handleDeleteInstallment = async (id) => {
    if (!window.confirm("Are you sure you want to delete this Installment?")) return;
    try {
      await axios.delete(`${Api}/api/installment/${id}`);
      setInstallments(installments.filter((i) => i._id !== id));
      toast.success("Deleted Successfully");
    } catch (err) {
      console.error("Error deleting installment", err);
    }
  };

  const handleAddInstallment = (newInstallment) => setInstallments([...installments, newInstallment]);

  return (
    <div>
      {loading && <Preloader loading={loading} />}

      {/* ── Page Header ── */}
      <div style={{ marginBottom: 20 }}>
        <h4 style={{ margin: 0, fontWeight: 700, color: "#1A202C", fontSize: 18 }}>Installments</h4>
        <div style={{ fontSize: 12, color: "#718096", marginTop: 3 }}>
          <span style={{ color: "#A0AEC0" }}>VFC</span>
          <span style={{ margin: "0 6px", color: "#CBD5E0" }}>›</span>
          <span style={{ color: "#2E7D32", fontWeight: 600 }}>Installments</span>
        </div>
      </div>

      {/* ── Table Card ── */}
      <div style={{ background: "#fff", borderRadius: 12, border: "1px solid #E2E8F0", boxShadow: "0 1px 4px rgba(0,0,0,0.07)", overflow: "hidden" }}>
        <div style={{ display: "flex", alignItems: "center", gap: 10, padding: "12px 16px", background: "linear-gradient(135deg,#1B5E20,#2E7D32)" }}>
          <span style={{ width: 30, height: 30, background: "rgba(255,255,255,0.15)", borderRadius: 8, display: "flex", alignItems: "center", justifyContent: "center", color: "#fff", fontSize: 15 }}>
            <i className="mdi mdi-credit-card" />
          </span>
          <span style={{ fontSize: 13, fontWeight: 700, color: "#fff", flex: 1 }}>Installment List</span>
          {permissions.includes("AddInstallment") && (
            <button onClick={() => setShowAddPopup(true)}
              style={{ display: "inline-flex", alignItems: "center", gap: 6, padding: "7px 14px", background: "rgba(255,255,255,0.2)", color: "#fff", border: "1px solid rgba(255,255,255,0.4)", borderRadius: 8, fontSize: 12, fontWeight: 700, cursor: "pointer" }}>
              <i className="mdi mdi-plus" /> Create New
            </button>
          )}
        </div>

        <div style={{ padding: 16, overflowX: "auto" }}>
          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead>
              <tr>
                <th style={thStyle}>#</th>
                <th style={thStyle}>Installment Name</th>
                <th style={thStyle}>Installment Number</th>
                {permissions.includes("EditInstallment") && permissions.includes("DeleteInstallment") && (
                  <th style={thStyle}>Actions</th>
                )}
              </tr>
            </thead>
            <tbody>
              {installments.length === 0 ? (
                <tr>
                  <td colSpan={4} style={{ ...tdStyle, textAlign: "center", color: "#A0AEC0", padding: "40px" }}>No installment records found.</td>
                </tr>
              ) : (
                installments.map((item, index) => (
                  <tr key={item._id} style={{ background: index % 2 === 0 ? "#fff" : "#F7FAFC" }}>
                    <td style={tdStyle}>{index + 1}</td>
                    <td style={{ ...tdStyle, fontWeight: 600, color: "#2D3748" }}>{item.installmentName}</td>
                    <td style={tdStyle}>{item.installmentNumber}</td>
                    {permissions.includes("EditInstallment") && permissions.includes("DeleteInstallment") && (
                      <td style={tdStyle}>
                        <i className="mdi mdi-pen" style={{ fontSize: "1.4rem", cursor: "pointer", marginRight: 8, color: "#2E7D32" }}
                          onClick={() => { setCurrentInstallment(item); setShowEditPopup(true); }} />
                        <i className="mdi mdi-delete" style={{ fontSize: "1.4rem", cursor: "pointer", color: "#E53E3E" }}
                          onClick={() => handleDeleteInstallment(item._id)} />
                      </td>
                    )}
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>

      {showAddPopup && <AddInstallment onClose={() => setShowAddPopup(false)} onAddInstallment={handleAddInstallment} />}
      {showEditPopup && currentInstallment && <EditInstallment installment={currentInstallment} onClose={() => { setShowEditPopup(false); setCurrentInstallment(null); }} />}
    </div>
  );
};

export default ManageInstallment;
